import HyperLink from '@acorn-portal/shared/src/components/hyperlink';
import { Typography } from '@mui/material';
import { IFooterDetail } from '@acorn-portal/shared/src/components/footer';

export const FooterDetails: IFooterDetail[] = [
	{
		title: 'Terms of Business',
		content: (
			<Typography
				component='a'
				href='https://www.carrotinsurance.com/docs/Terms-of-Business.pdf'
				target='_blank'
				rel='noreferrer'
				sx={{ color: 'white' }}
			>
				Our Terms of Business
			</Typography>
		),
	},
	{
		title: 'Registered Office Details',
		content: (
			<Typography>
				Carrot Insurance Services is a trading name of Acorn Insurance and Financial Services Limited which is
				authorised and regulated by the Financial Conduct Authority (FCA) Firm reference number 311873. Registered
				address: 98 Liverpool Road, Formby, Liverpool, Merseyside, L37 6BS, Registration No. 01636368.
			</Typography>
		),
	},
	{
		title: 'Contact Us',
		content: (
			<Typography>
				To get in touch, please click{' '}
				<Typography
					component='a'
					href='https://www.carrotinsurance.com/contact-us/'
					target='_blank'
					sx={{ color: 'white' }}
				>
					here.
				</Typography>
			</Typography>
		),
	},
	{
		title: 'Privacy Notice',
		content: (
			<Typography
				component='a'
				href='https://www.carrotinsurance.com/privacy-notice'
				target='_blank'
				sx={{ color: 'white' }}
			>
				Our Privacy Notice.
			</Typography>
		),
	},
];

const Copy = {
	keepingInformed: (
		<>
			Carrot Insurance and affiliated companies in our Group would like to occasionally contact you to tell you about
			new products, special offers and promotions, so you don&apos;t miss out. Further information can be found in our{' '}
			<HyperLink href='https://www.acorninsure.co.uk/docs/Privacy-Policy.pdf' target='_blank' rel='noreferrer'>
				Privacy Notice
			</HyperLink>
			. If you&apos;d prefer not to hear from us, please tick the relevant boxes below.
		</>
	),
};

export default Copy;
